import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import * as XLSX from "xlsx";

@Component({
  selector: "app-adminLisCorderos",
  templateUrl: "./adminLisCorderos.component.html",
  styleUrls: ["./adminLisCorderos.component.css"],
})
export class AdminLisCorderosComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  //datosTabla: any = [{}];
  datosTabla: any[] | null = null;
  filtroCliente: string = "";
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  modoLis = 0;
  prifec: string;
  ultfec: string;

  primerafecha: string;
  ultimafecha: string;

  clientes: any[] = [];
  clienteSeleccionado: any = 0;

  modoBorrado: boolean = false;

  editPedido: any = null;
  @ViewChild("modalEditar") modalEditar: any;

  private corderosSubscription: Subscription | null = null;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    this.srvCentral.listClientes().subscribe({
      next: (res) => {
        if (!res || res.length === 0) {
          this.clientes = [
            { ttSocio: 0, ttNombr: "No hay clientes", ttEsSocio: "" },
          ];
        } else {
          this.clientes = [
            { ttSocio: 0, ttNombr: "Todos", ttEsSocio: "" },
            ...res,
          ];
        }
      },
      error: (err) => {
        console.error("Error al cargar clientes:", err);
        this.clientes = [
          { ttSocio: 0, ttNombr: "Error en la consulta", ttEsSocio: "" },
        ];
      },
    });
  }

  editarLinea(pedido: any) {
    // Clonamos para no tocar el original hasta guardar
    this.editPedido = { ...pedido };

    this.modalService.open(this.modalEditar, { size: "md" });
  }

  guardarCambios() {
    this.srvCentral.entregacord(1, [this.editPedido]).subscribe({
      next: (resp) => {
        //alert("Entrega modificada correctamente");

        // Actualizamos la tabla visualmente
        const pos = this.datosTabla.findIndex(
          (p) =>
            p.ttSocio == this.editPedido.ttSocio &&
            p.ttFecha == this.editPedido.ttFecha &&
            p.ttOrden == this.editPedido.ttOrden,
        );

        if (pos >= 0) {
          this.datosTabla[pos] = { ...this.editPedido };
        }

        this.modalService.dismissAll();
      },
      error: (err) => {
        console.error("Error al modificar entrega", err);
        alert("No se pudo modificar la entrega");
      },
    });
  }

  toggleModoBorrado(): void {
    this.modoBorrado = !this.modoBorrado;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  borrarLinea(pedido: any): void {
    const confirmado = confirm("¿Seguro que quieres borrar esta entrega?");
    if (!confirmado) return;

    this.srvCentral.entregacord(2, [pedido]).subscribe({
      next: (resp) => {
        alert("Entrega borrada correctamente");
        // Eliminar visualmente la línea de la tabla
        this.datosTabla = this.datosTabla.filter((p: any) => p !== pedido);
      },
      error: (err) => {
        console.error("Error al borrar entrega:", err);
        alert("Error al borrar la entrega");
      },
    });
  }

  cargarPedidos(): void {
    const fechaDesde = this.formatearFecha(this.primerafecha);
    const fechaHasta = this.formatearFecha(this.ultimafecha);

    if (this.corderosSubscription) {
      this.corderosSubscription.unsubscribe();
    }

    if (!this.clienteSeleccionado || this.clienteSeleccionado == 0) {
      this.srvCentral
        .listarCorderos(fechaDesde, fechaHasta)
        .subscribe((res) => {
          this.datosTabla = res;
          //console.log("Datos tabla:", this.datosTabla);
          this.dtTrigger.next(null);
        });
    } else {
      this.srvCentral
        .listarCorderos(fechaDesde, fechaHasta, this.clienteSeleccionado)
        .subscribe((res) => {
          this.datosTabla = res;
          //console.log("Datos tabla:", this.datosTabla);
          this.dtTrigger.next(null);
        });
    }
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return "";
    const [year, month, day] = fecha.split("-");
    return `${day}-${month}-${year}`;
  }

  exportarAExcel(): void {
    if (!this.datosTabla || this.datosTabla.length === 0) {
      return;
    }

    const encabezados = [
      "Fecha",
      "Socio",
      "Nombre",
      "Explotación",
      "Hembras",
      "Machos",
      "Total",
      "Recogida",
    ];

    const filas = this.datosTabla.map((pedido: any) => [
      pedido.ttFecha,
      pedido.ttSocio,
      pedido.ttNombr,
      pedido.ttExplo,
      pedido.ttHembra,
      pedido.ttMachos,
      pedido.ttTotcor,
      pedido.ttRecoge === 0 ? "SI" : pedido.ttRecoge === 1 ? "NO" : "COOP",
    ]);

    const wsData = [encabezados, ...filas];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = encabezados.map(() => ({ wch: 15 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Entregas");

    const fecha = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `entregas_${fecha}.xlsx`);
  }
}
